import { useState, useEffect, useCallback, useRef } from 'react';

const DEFAULT_DURATION = 60;
const STORAGE_KEY = 'biblika_timer_duration';

export const TIMER_OPTIONS = [0, 10, 15, 20, 30, 60];

export function getTimerDuration() {
  try {
    const saved = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    return TIMER_OPTIONS.includes(saved) ? saved : DEFAULT_DURATION;
  } catch { return DEFAULT_DURATION; }
}

export function setTimerDuration(seconds) {
  localStorage.setItem(STORAGE_KEY, String(seconds));
}

export default function useTimer(onTimeout) {
  const duration = getTimerDuration();
  const disabled = duration === 0;
  const [seconds, setSeconds] = useState(disabled ? 0 : duration);
  const [running, setRunning] = useState(!disabled);
  const callbackRef = useRef(onTimeout);
  callbackRef.current = onTimeout;

  useEffect(() => {
    if (!running || seconds <= 0) return;
    const id = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          setRunning(false);
          callbackRef.current?.();
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [running, seconds]);

  const stop = useCallback(() => setRunning(false), []);

  const reset = useCallback(() => {
    const dur = getTimerDuration();
    setSeconds(dur === 0 ? 0 : dur);
    setRunning(dur !== 0);
  }, []);

  return { seconds, total: duration, running, stop, reset };
}
